import Snippet from "./Snippet";

export default Snippet;
export { Snippet };
